import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import Products from "./pages/Products";
import Books from "./pages/Books";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/produkte" element={<Products />} />
                    <Route path="/buecher" element={<Books />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#FDFBF7",
                        color: "#2C2724",
                        border: "1px solid #DCD5CE",
                        borderRadius: "0",
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 300,
                    },
                }}
            />
        </div>
    );
}

export default App;
